import React, { useEffect} from 'react';
import { get } from 'lodash';
import { useLocation } from 'react-router-dom';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getContentOurAdsCall from '@kfc-global/react-shared/redux/Actions/OurAdsAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { useSelector, useDispatch } from 'react-redux';
import { StartOrderComponent } from '../../../organisms/StartOrderComponent';
import { Footer } from '../../../organisms/FooterComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from '../../homePageContainer/Constants/homePageContainerConstants';
import { Header } from '../../../organisms/HeaderComponent';
import OurAdsContainer from '../../../organisms/OurAds/Container/OurAdsContainer';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  isEmptyObject,
  getTenantData,
  getOurAdsData,
  isCurrentPageRedirectFromRNA,
} from 'common/utilities/utils';
import { getCmsClient } from '../../../common/utilities/cmsClient';
import { ChannelManager } from 'common/manager';

const OurAdsComponent = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispatch = useDispatch();

  let userParams = useSelector(data => data.appStateReducer.userStatus);

  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': tenantReducer?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
  }, [dispatch, userParams]);

  /* to hide header/footer  dynamically */
  const location = useLocation();
  const hide_nav = isCurrentPageRedirectFromRNA(location, ['/ourAds']);

  useEffect(() => {
    dispatch(
      getContentOurAdsCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': 'About Our Ads',
          include: '5',
        },
      }),
    );
  }, [dispatch]);

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTenantData = null,
    segmentedOurAds = null,
    segmentedFooterData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const allReducerData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
      marketPageContent: get(data, 'marketConfigReducer.response', null),
      tenantReducerContent: get(data, 'tenantReducer', null),
      ourAdsContent: get(data, 'ourAdsReducer.response', null),
    };
  });

  if (
    allReducerData.marketPageContent &&
    allReducerData.tenantReducerContent &&
    allReducerData.homePageContent &&
    isEmptyObject(allReducerData.ourAdsContent)
  ) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const { header = {}, tenant = [], footer = {} } = allReducerData.marketPageContent.headerData;
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
    segmentedOurAds = getOurAdsData(allReducerData.ourAdsContent);
  }

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && !hide_nav && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      {!hide_nav && (
        <StartOrderComponent
          contentData={{
            segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
            contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
          }}
          userParams={userParams}
        />
      )}
      {isEmptyObject(segmentedOurAds) && <OurAdsContainer contentData={segmentedOurAds} />}
      {(isEmptyObject(segmentedFooterData) && !hide_nav && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
    </React.Fragment>
  );
};

export default OurAdsComponent;
